module.exports = __webpack_public_path__ + "static/media/modal-chatbot.d56330af.png";